import { useSetAtom } from 'jotai';

import {
  drawerIsOpenAtom,
  drawerTypeAtom,
} from '@/features/equipment-browser/equipment-drawer-loader/state/drawer.state';

import { deviceIdsAtom, deviceKindAtom } from '../state/bulk-edit-params.state';

export const useOpenBulkEdit = () => {
  const setDeviceKind = useSetAtom(deviceKindAtom);
  const setDeviceIds = useSetAtom(deviceIdsAtom);
  const setDrawerIsOpen = useSetAtom(drawerIsOpenAtom);
  const setDrawerType = useSetAtom(drawerTypeAtom);

  const openBulkEditAction = (deviceKind: string, deviceIds: string[]) => {
    setDeviceKind(deviceKind);
    setDeviceIds(deviceIds);
    setDrawerType('bulk-edit');
    setDrawerIsOpen(true);
  };

  const clearBulkEditAction = () => {
    setDeviceKind(undefined);
    setDeviceIds(undefined);
    setDrawerIsOpen(false);
    setDrawerType(undefined);
  };

  return {
    openBulkEditAction,
    clearBulkEditAction,
  };
};
